import {
  BorderColor,
  Description,
  Favorite,
  HelpOutline,
  LocationOn,
  Money,
  NoAccounts,
  Translate,
  Visibility,
} from "@mui/icons-material";

export const profileItems = [
  {
    icon: <Money />,
    titile: "My Earning",
    path: "/earnings",
  },

  {
    icon: <Favorite />,
    titile: "My Wishlist",
    path: "/wishlist",
  },

  {
    icon: <Description />,
    titile: "My Billings Details",
    path: "/billing-details",
  },

  {
    icon: <BorderColor />,
    titile: "My Orders",
    path: "/orders",
  },
  {
    icon: <Description />,
    titile: "My Invoices",
    path: "/invoices",
  },

  {
    icon: <Visibility />,
    titile: "My Reviews",
    path: "/my-reviews",
  },

  {
    icon: <HelpOutline />,
    titile: "My Question & Answers",
    path: "/questions-answers",
  },
  {
    icon: <NoAccounts />,
    titile: "Account Deletion",
    path: "/account-deletion",
  },
  {
    icon: <Translate />,
    titile: "Choose Language",
    path: "/choose-language",
  },
  {
    icon: <LocationOn />,
    titile: "Store Locations",
    path: "/store-locations",
  },
];
